module.exports = __webpack_public_path__ + "svg/php.6e7c94.svg";